.AppCrashed {
    width: 100%;
    height: 100vh;
    max-height: 100vh;

    display: flex;
    align-items: center;
    justify-content: center;

  .card {
    min-width: 50rem;
    min-height: 20rem;
    max-height: 80vh;

    overflow: scroll;
   
    padding: 3rem;

    display: flex;
    flex-direction: column;
    align-items: center;

    row-gap: 2rem;

    text-align: center;
  }

  .error {
    margin: 0;
    row-gap: 0;
  }

  .stackTrace {
    color: black;
    white-space: pre-wrap;
    text-align: left;
  }

  .line {
    display: flex;
    flex-direction: row;
    column-gap: 4rem;
  }
  
}